import {useMutation} from "@tanstack/react-query"

import {api, DraftReplyRequest, DraftReplyResponse} from "./index"

type DraftReplyParams = {
	customerID: string
	conversationID: string
	providerMessageId: string
} & DraftReplyRequest

export function useDraftReply() {
	return useMutation({
		mutationFn: ({
			customerID,
			conversationID,
			providerMessageId,
			...payload
		}: DraftReplyParams): Promise<DraftReplyResponse> =>
			api.customer.draftReply(customerID, conversationID, providerMessageId, payload),
	})
}
